export default (block, modifiers = [], extraClasses) => {
  const classNames = [block]

  if (typeof modifiers === "string") {
    classNames.push(`${block}--${modifiers}`)
  } else if (Array.isArray(modifiers)) {
    modifiers.forEach((modifier) => {
      if (modifier) {
        classNames.push(`${block}--${modifier}`)
      }
    })
  }

  if (typeof extraClasses === "string") {
    classNames.push(extraClasses)
  } else if (Array.isArray(extraClasses)) {
    extraClasses.forEach((className) => {
      if (className) {
        classNames.push(className)
      }
    })
  }

  return classNames.join(" ")
}
